import { DrmPfInformation } from "@/types/drmPfInformation";
import { useNavigate } from "react-router-dom";
import { useDrmPfInformationSearch } from "@/stores/drmPfInformationSearch";
import * as Common from "@/utils/common";
import React from "react";
import {CustomMarkdown} from "@/components/CustomMarkdown";

export const ResultItem = ( { drmPfInformation, index }: { drmPfInformation: DrmPfInformation, index: number } ) => {
  const navigate = useNavigate();
  const { setBackPage } = useDrmPfInformationSearch();
  const onClickDetail = () => {
    setBackPage("/");
    navigate(`/${drmPfInformation.id}`);
  };
  const newFlag = () => {
    const releaseDate = new Date(drmPfInformation.release_date)
    const targetDate = new Date()
    targetDate.setHours(0, 0, 0, 0);
    targetDate.setDate(targetDate.getDate() - 14);
    return targetDate <= releaseDate;
  };

  return (
    <div
      className="drmPfInformation-search-result-item"
      key={index}
      onClick={onClickDetail}
    >
      <div className="uk-flex uk-flex-between">
        <div className="uk-flex">
          <p className="uk-text-medium-s uk-text-bold">{drmPfInformation.display_num}</p>
          <p className="uk-text-medium-s uk-text-bold margin-left-24">
            {drmPfInformation.title}
          </p>
        </div>
        {newFlag() && <div className="new-label">NEW</div>}
      </div>
      <div className="description">
        <p className="uk-text-default description-question">
          <CustomMarkdown content={drmPfInformation?.body}/>
        </p>
      </div>
      <div className="uk-flex uk-flex-between uk-margin-top margin-left-32">
        <div className="uk-flex">
          <div className="uk-flex uk-flex-middle width-175">
            <p className="tag-dark">管理番号</p>
            <p className="uk-text-default margin-left-16">{Common.controlNum(drmPfInformation.id)}</p>
          </div>
          <div className="uk-flex uk-flex-middle width-175">
            <p className="tag-dark">公開日</p>
            <p className="uk-text-default margin-left-27">{drmPfInformation.release_date}</p>
          </div>
        </div>
        <div className="uk-flex uk-flex-wrap gap-10 uk-margin-small-right">
          <p className="tag-light">{drmPfInformation.drm_pf_information_type.name}</p>
        </div>
      </div>
    </div>
  );
};